import React, { createContext, useCallback, useContext, useReducer } from 'react';

// creating a context for easy prop passing.
const defaultPopperState = {
  open: false,
  isEditing: false,
  anchorEl: null,
  placement: null,
  onClose: null,
  component: null,
};

const PopperContext = createContext(defaultPopperState);

const popperActions = {
  SHOW_POPPER: 'SHOW_POPPER',
  HIDE_POPPER: 'HIDE_POPPER',
};

const PopperActionsReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case popperActions.SHOW_POPPER:
      return {
        ...state,
        open: true,
        anchorEl: payload.anchorEl,
        onClose: payload.onClose,
        component: payload.component,
        placement: payload.placement,
      };
    case popperActions.HIDE_POPPER:
      return {
        ...state,
        open: false,
        anchorEl: null,
        onClose: null,
        component: null,
        placement: null,
      };

    default:
      return state;
  }
};

export const PopperProvider = ({ children }) => {
  const [state, popperDispatch] = useReducer(PopperActionsReducer, defaultPopperState);

  // popper control functions.
  const showPopper = useCallback(({ anchorEl, onClose, component, placement = 'bottom' }) => {
    popperDispatch({
      type: popperActions.SHOW_POPPER,
      payload: {
        anchorEl,
        onClose,
        component,
        placement,
      },
    });
  }, []);

  const hidePopper = useCallback(() => {
    popperDispatch({
      type: popperActions.HIDE_POPPER,
      payload: {},
    });
  }, []);

  return (
    <PopperContext.Provider
      value={{
        state,
        showPopper,
        hidePopper,
      }}
    >
      {children}
    </PopperContext.Provider>
  );
};

const usePopperState = () => useContext(PopperContext);

export { usePopperState };
